export default {

	init() {
		console.log('init tabs...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		$('[data-tab]').on('click', function (e) {
			Tabs.switchTab(this);
		});
	},

	switchTab(elem) {
		let $tab = $(elem);
		let $target = $('#' + $tab.attr('aria-controls'));
		let url = elem.dataset.url;

		if (!$target.length) {
			return;
		}

		let $tablist = $tab.parents('[role=tablist]').first().find('[aria-controls]');
		let $tabpanels = $target.parents('.tabs-content').first().find('[aria-labelledby]');

		$tablist.removeClass('is-active').attr('aria-selected', 'false');
		$tab.addClass('is-active').attr('aria-selected', 'true');

		$tabpanels.removeClass('is-active');
		$target.addClass('is-active');

		if (url) {
			this.updateUrl(url);
		}
	},

	updateUrl(url) {
		if(window.history.pushState) {
			window.history.pushState({}, '', url);
		}
	},

};
